<template>
  <router-view/>
</template>
<script>
  export default {
    methods:{
      handleResize() {
        var htmlWidth = document.documentElement.clientWidth|| document.body.clientWidth
        let htmlDom=document.getElementsByTagName('html')[0]
        htmlDom.style.fontSize= 25 / 1920 * htmlWidth + 'px'
      }
    },
    mounted(){
      this.handleResize()
      window.onresize = this.handleResize
    }
}
</script>
<style lang="less">
* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box; 
}
body,html {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  // font-size: 20px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}


</style>
